import type {StockPanelProps} from '@Panels/stock-panel/stock-panel';

/** Screens the popup host can show; 'stock' is the default. */
export type EmailStockPopupView = 'stock' | 'ai-images' | 'ai-stickers' | 'video-options' | 'ai-videos' | 'image-options';

/** Tile callbacks for the 'video-options' view that leave the popup (Explore media / AI Videos navigate within it). */
export interface EmailStockPopupVideoOptions {
  onMyUploads: () => void;
  onEmbedVideo: () => void;
  /** Fires on every option-tile click, before its panel opens — the fresh-add flow appends the video placeholder here. */
  onSourceSelected?: () => void;
}

/** Tile callbacks for the 'image-options' view that leave the popup (Explore media / AI Images navigate within it). */
export interface EmailStockPopupImageOptions {
  onMyUploads: () => void;
  onMyDesigns: () => void;
}

/** What the media-modals library asks the popup host to show. */
export interface EmailStockPopupRequest {
  overrides: Partial<StockPanelProps>;
  /** First screen shown instead of the stock grid ('video-options' / 'image-options' = the source choosers). */
  initialView?: Extract<EmailStockPopupView, 'ai-images' | 'ai-stickers' | 'video-options' | 'ai-videos' | 'image-options'>;
  videoOptions?: EmailStockPopupVideoOptions;
  imageOptions?: EmailStockPopupImageOptions;
  /**
   * Sub-views (stock grid / AI panels) reached from a chooser return to the chooser on Back by default. The
   * fresh-add flows set this so Back exits to the screen that opened the popup instead (e.g. the Elements
   * dropdown) — consistent with the other Elements tiles, which open their grids directly.
   */
  exitOnSubViewBack?: boolean;
  /** Runs after the popup closes via the header's Back — returns the user to the screen that opened the popup (e.g. reopens a block panel). */
  onNavigateBack?: () => void;
  /** DOM id of the left-menu tile the popup arrow points at; defaults to the Elements tile when omitted. */
  arrowAnchorTileId?: string;
}

export const EMAIL_STOCK_POPUP_DEFAULT_PANEL_ID = 'email-stock-panel';

export const EMAIL_STOCK_POPUP_AI_IMAGE_PANEL_ID = 'EMAIL_STOCK_POPUP_AI_IMAGE_PANEL';

export const EMAIL_STOCK_POPUP_AI_VIDEO_PANEL_ID = 'EMAIL_STOCK_POPUP_AI_VIDEO_PANEL';

/** Visual gap between the left panel and the popup — matches the block panels' PANEL_OFFSET_LEFT. */
export const EMAIL_STOCK_POPUP_OFFSET_PX = 6;

/** Matches the block panels' arrow — dropdown-v2 renders FloatingArrow at floating-ui's default 14×7. */
export const EMAIL_STOCK_POPUP_ARROW_WIDTH_PX = 14;

export const EMAIL_STOCK_POPUP_ARROW_HEIGHT_PX = 7;
